import VConsole from 'vconsole';

let vConsoleInstance = null

export function showVConsole() {
  if (!vConsoleInstance) {
    vConsoleInstance = new VConsole()
  }
  vConsoleInstance.show()
}

export function hideVConsole() {
  if (vConsoleInstance) {
    vConsoleInstance.hide()
  }
}




// WEBPACK FOOTER //
// ./src/vconsole.js